import { render, staticRenderFns } from "./OrganizationBasicInfo.vue?vue&type=template&id=04462745&"
import script from "./OrganizationBasicInfo.vue?vue&type=script&lang=js&"
export * from "./OrganizationBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports